<template>
  <div class="leadership">

    <div class="leadership__bg" :class="{ 'leadership__bg--evaluation': start }"></div>

    <div transition="expand" class="leadership__container">

      <leadership-info v-if="!start">
        <button @click="startTraits" class="custom-btn custom-btn--green" :disabled="!openSection">Start</button>
      </leadership-info>

      <div v-else>
        <h1 class="leadership__traits-title text-center">Leadership</h1>
        <dots-number activeDots='5'/>
        <indicators :indicators="indicatorsList" section="Leadership" rocketNo="5"/>
      </div>

    </div>

  </div>
</template>

<script>
// API
import traitsApi from '@/api/traits';
// Components
import LeadershipInfo from '@/components/Evaluation/Leadership/Info';
import DotsNumber from '@/components/Evaluation/Dots';
import Indicators from '@/components/Evaluation/Indicators';

export default {
  components: { LeadershipInfo, DotsNumber, Indicators },
  props: ['sectionId'],
  data() {
    return {
      start: false,
      indicatorsList: [],
      openSection: false,
    };
  },
  methods: {
    startTraits() {
      this.start = true;
    },
  },
  created() {
    if (this.sectionId) {
      traitsApi.index(this.sectionId).then((response) => {
        response.data.traits.map(trait => trait.indicators.map(indicator => this.indicatorsList.push(indicator)));
        this.indicatorsList = this.indicatorsList.sort(() => 0.5 - Math.random());
        this.openSection = true;
      });
    } else {
      this.$router.push({ name: 'sections' });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/Leadership/Index.vue